export enum EnumReasonResetPassword {
    Create = 'create',
    Modify = 'modify',
    Loose = 'loose',
}
